'use client'

import PropTypes from 'prop-types'
import MUIInput from '@mui/material/TextField'
import { CaretDownIcon } from '@repo/ui/CaretDownIcon'

export const WizardFormInput = ({
  children,
  value = '',
  name,
  label,
  type = 'text',
  autoFocus = false,
  required = false,
  disabled = false,
  select = false,
  multiple = false,
  onChange,
  onKeyDown,
  errors = {},
  sx,
  size = 'normal',
  isDropDown = false,
  isOpen = false
}) => {
  const handleChange = (e) => {
    if (onChange) onChange(e.target.value, e)
  }

  const handleKeyDown = (e) => {
    if (onKeyDown) {
      onKeyDown(e)
    }
  }

  return (
    <MUIInput
      sx={{ width: 'calc(50% - 8px)', ...sx }}
      data-testid={name}
      id={name}
      name={name}
      label={errors[name] ? errors[name] : label}
      type={type}
      autoFocus={autoFocus}
      required={required}
      disabled={disabled}
      select={select}
      multiple={multiple}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      value={value}
      error={errors[name] ? true : false}
      size={size}
      InputProps={{
        endAdornment: isDropDown ? (
          <CaretDownIcon
            sx={{ color: 'rgba(0, 0, 0, 0.54)', mr: -2, transform: `rotate(${isOpen ? '-180' : '0'}deg)` }}
          />
        ) : null
      }}
    >
      {children}
    </MUIInput>
  )
}

WizardFormInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  select: PropTypes.bool,
  multiple: PropTypes.bool,
  sx: PropTypes.object,
  children: PropTypes.any,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  errors: PropTypes.object,
  value: PropTypes.string,
  size: PropTypes.string,
  isDropDown: PropTypes.bool,
  isOpen: PropTypes.bool
}
